<template>
  <div class="infoSmallTile">
    <div
      :class="[
        'infoSmallTile__wrapper',
        { 'infoSmallTile__wrapper--isBanner': isBanner },
        { 'infoSmallTile__wrapper--centerContent': centerContent },
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoSmallTile',
  props: {
    isBanner: {
      type: Boolean,
      default: false,
    },
    centerContent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.infoSmallTile {
  $root: &;

  &__wrapper {
    display: flex;
    background-color: $cWhite;

    &--centerContent {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    &--isBanner {
      background-image: url('/images/cart/cart-info-bg2.svg');
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: 100%;
      border: 10px solid $cWhite;
      height: 100%;
      min-height: 17rem;
      // padding-top: 1.4rem;

      @include rwd('large-tablet') {
        // background-size: cover;
        // background-position: bottom center;
      }

      @include rwd('small-tablet') {
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        // background-position: 80% 100%;
        // background-size: 150%;
        min-height: 26rem;
      }
    }
  }
}
</style>
